import React, { Component } from 'react';
import { Context } from 'context';

import styles from "./UtilityBar.module.scss";
import CodeLabel from "components/codeLabel/CodeLabel";
import Hints from "editor/utilitybar/hints/Hints";
import Breadcrumb from "editor/utilitybar/breadcrumb/Breadcrumb";

export default class UtilityBar extends Component {
    static contextType = Context;

    componentDidMount() {
        let tipsConfirmed = localStorage.getItem(`sw-editor-tipsConfirmed`) && JSON.parse(localStorage.getItem(`sw-editor-tipsConfirmed`));

        if (!tipsConfirmed){
            this.context.confirm("Tip: Look for the info icon at the bottom left - it gives you hints about things you hover on. You can also hover on it to see extra information", "neutral", false).then(() => {
                localStorage.setItem("sw-editor-tipsConfirmed", JSON.stringify(true));
            })
        }
    }

    render() {
        return (
            <div className={`bgTertiary highlightSecondary ${styles.utilityBar}`}>
                <Hints/>
                <Breadcrumb selectedMapId={this.props.selectedMapId}/>
                <div className={styles.buttons}>
                    <span className={`highlightSecondary ${this.props.showNavigator && "bgPrimary"}`} onClick={this.props.toggleNavigator}>Hex Viewer</span>
                </div>
            </div>
        )
    }
}